export const formatPostalCode = (input: string, space = false) => {
    // removes whitespace on ends, makes uppercase, and removes non-alphanumeric characters
    const postalCode = input.trim().toUpperCase().replace(/\W/g,'');
    // adds space after third character if desired, trims to desired length
    if (space) return postalCode.replace(/(...)/,'$1 ').slice(0,7);
    return postalCode.slice(0,6);
}

export const validatePostalCode = (input: string) => {
    // postal codes do not include D, F, I, O, Q, or U, and first position cannot be W or Z
    // space in fourth position is optional
    // https://www150.statcan.gc.ca/n1/pub/92-154-g/2015001/tech-eng.htm
    const regex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;
    return regex.test(input);
}